'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _docs = require('redux/modules/docs');

var _ = require('..');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  InfoBar: {
    displayName: 'InfoBar'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/DocList/DocList.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import {Scrollable} from '..';


var InfoBar = _wrapComponent('InfoBar')((_dec = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ load: _docs.load }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(InfoBar, _Component);

  function InfoBar() {
    (0, _classCallCheck3.default)(this, InfoBar);
    return (0, _possibleConstructorReturn3.default)(this, (InfoBar.__proto__ || (0, _getPrototypeOf2.default)(InfoBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(InfoBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          items = _props.items,
          parentPropName = _props.parentPropName,
          parentItem = _props.parentItem,
          currentId = _props.currentId,
          onItemClick = _props.onItemClick; // eslint-disable-line no-shadow
      // const items = data.docs[propName];

      var styles = require('./DocList.scss');
      var isInPlaylistItem = parentItem && parentItem.id.startsWith('p:');

      if (parentPropName && !parentItem) {
        return _react3.default.createElement('span', null);
      }
      var prevFirstLetter = '';

      var getPicture = function getPicture(item) {
        return item.createdByObj ? _react3.default.createElement('img', { src: item.createdByObj.picture || '/user.png', alt: 'by ' + item.createdByObj.visibleName }) : null;
      };
      var getAuthorName = function getAuthorName(item) {
        return item.createdByObj && item.createdByObj.visibleName ? _react3.default.createElement(
          'span',
          { className: styles.itemAuthor },
          'by ',
          item.createdByObj.visibleName,
          ' '
        ) : null;
      };

      var getBody = function getBody(item) {
        var name = item.name;
        if (item.uiType === 'playlist') {

          return _react3.default.createElement(
            'div',
            { className: styles[item.uiType] },
            '# ',
            _react3.default.createElement(
              'i',
              null,
              name
            ),
            ' ',
            getPicture(item),
            ' ',
            _react3.default.createElement('br', null),
            ' ',
            getAuthorName(item)
          );
        }

        if (name && name.length > 0) {
          var firstLetter = name.substring(0, name.startsWith('Ch') ? 2 : 1);
          if (firstLetter === prevFirstLetter) {
            return name;
          }
          prevFirstLetter = firstLetter;
          if (name && name.length > 0) return _react3.default.createElement(
            'span',
            null,
            _react3.default.createElement(
              'b',
              null,
              firstLetter
            ),
            name.substring(firstLetter.length)
          );
        }
        return name;
      };

      // let heading = '';
      // if (parentItem) {
      //   heading = <h1>{parentItem && parentItem.name} : &nbsp;&nbsp;&nbsp;<small>[ {items && items.length} ]</small></h1>;
      // }
      var children = (items || []).map(function (item, keyIndex) {
        if (item.isSeparator) return item.name ? _react3.default.createElement(
          'h2',
          null,
          item.name
        ) : _react3.default.createElement(
          'div',
          null,
          '\xA0'
        );
        return _react3.default.createElement(
          _.TreeItem,
          { position: keyIndex, active: currentId === item.id, prefix: isInPlaylistItem ? keyIndex + 1 + '' : '', item: item, key: keyIndex, parentItem: parentItem, onClick: onItemClick, className: item.uiType },
          getBody(item)
        );
      });
      return _react3.default.createElement(
        'div',
        { className: styles.docList },
        _react3.default.createElement(
          'ul',
          { className: 'list-group' },
          children
        )
      );
    }
  }]);
  return InfoBar;
}(_react2.Component), _class2.propTypes = {
  // docs: PropTypes.object,
  // load: PropTypes.func.isRequired,
  items: _react3.default.PropTypes.arrayOf(_react3.default.PropTypes.object),
  currentId: _react2.PropTypes.string,
  parentPropName: _react2.PropTypes.string,
  parentItem: _react2.PropTypes.object,
  panelVisibleToSide: _react2.PropTypes.func.isRequired,
  onItemClick: _react2.PropTypes.func
}, _temp)) || _class));

exports.default = InfoBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DocList/DocList.js
// module id = 1176
// module chunks = 0